export default __webpack_public_path__ + "static/media/doctor1.ff51102c.jpg";